<template>
<div>
    <div class="mcc-page-header">
        <div class="mu-d-flex">
            <div class="mu-d-flex">
                <section class="mu-d-flex mu-flex-row">
                    <h1 class="mu-mb-00">Deployments</h1>
                    <details class="mcc-popover mcc-popover--bottom-end">
                        <summary class="mcc-button mcc-button--icon-only ">
                            <mcc-icon name="help" aria-hidden="true"></mcc-icon>
                        </summary>
                        <div class="mcc-popover__content">

                            <p class="mu-mb-00">
                                {{ helpText.title }}
                                <a :href="helpText.url" target="_blank">Read more...</a>
                            </p>
                        </div>
                    </details>
                </section>
                <section>

                </section>
            </div>

        </div>
    </div>
    <div class="mcc-container--fluid card-padding">
        <nav aria-label="breadcrumb">
            <ol class="mcc-breadcrumb">
                <li>Process engine</li>
                <li>Deployments</li>
                <li class="lastBredCrumpLi">

                </li>
            </ol>
        </nav>
       
            
        <div class="mcc-row" v-if="!fetchCall">
            <div class="mcc-col colSpinner">
                <div class="spinner-overlay">
                    <div class="spinner-background"></div>
                    <div class="spinner-flex">
                        <svg viewBox="0 0 50 50" class="mcc-spinner" animated="" style="width: 48px; height: 48px; ">
                            <circle class="mcc-spinner__track" cx="25" cy="25" r="20" fill="none" stroke-width="5">
                            </circle>
                            <circle cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                        </svg>
                    </div>
                </div>

            </div>

        </div>

        <div class="mcc-row" id="deploymentRow">
            <div class="mcc-col">
                <div class="mcc-card">
                    <div class="mcc-card__body">
                        <div class="mcc-row mu-px-04">
                            <mcc-alert role="alert" class="mcc-alert mcc-alert--info mcc-alert--compact" v-if="showNoRecords" >
                                <mcc-icon name="info" aria-hidden="true"></mcc-icon>
                                <span >No process deployments found</span>

                                <button class="mcc-button mcc-button--info mcc-button--sm mcc-button--icon-only" style="margin-inline-start: auto">
                                    <mcc-icon name="close" icon-set="fluency-outline" aria-hidden="true"></mcc-icon>
                                    <span class="mcc-button__label">Button</span>
                                </button>
                            </mcc-alert>
                        </div>
                        <div class="mcc-row"  v-show="showDeployments">
                            <div class="mcc-col">
                                <div class="mu-pb-05 mu-radius-top">
                                    <div class="mfc-input-wrapper">
                                        <div class="mfc-input-group mfc-input-group--leading-icon">
                                            <mcc-icon class="mfc-input-group__icon mu-mt-02" name="search" id="list-group-icon" aria-hidden="true"></mcc-icon>
                                            <input id="list-group-filter" name="list-group-filter" type="text" placeholder="Type to search...">
                                        </div>
                                    </div>
                                </div>
                                <ul class="mcc-list-group">
                                    <li v-for="(app, key) in deploymentList" :key="key" class="mcc-list-group-li">

                                        <details class="mcc-collapse mu-w-100" @click="handleExpand(key)" :id="'collapseDeployment' + key">
                                            <summary>
                                                <div class="mcc-menu__button">
                                                    <div class="mu-w-100 mu-gap-03">
                                                        <div>{{ app.name }}</div>
                                                        <div> <small>
                                                                Deployed {{ app.prettyDeploymentTime }}
                                                            </small></div>

                                                    </div>
                                                </div>
                                                <span class="mcc-chip mcc-chip--xs  mcc-chip--success mu-mr-03" v-if="!app.undeployed">Active</span>
                                                <span class="mcc-chip  mcc-chip--xs mcc-chip--warning mu-mr-3" v-if="app.undeployed">Undeployed</span>
                                                <span class="mcc-chip  mcc-chip--xs  mcc-chip--info mu-mr-03">{{ app.deployedList.length + 1 }}</span>
                                                <mcc-icon class="mcc-button__dropdown-caret" name="expand_arrow" aria-hidden="true"></mcc-icon>
                                            </summary>
                                            <div class="mcc-collapse-body mu-mt-03">
                                                <mcc-data-table ref="myTable" :id="'myTable'+key"></mcc-data-table>
                                            </div>
                                        </details>

                                    </li>
                                </ul>

                            </div>

                        </div>

                    </div>

                </div>

            </div>

        </div>

    </div>

</div>
</template>

<script>
import constantMessages from "../../../messages";
import DeploymentAPI from "../../../services/DeploymentAPI";
import Utils from "@/script_utils";
import Drawer from '../../common/Drawer.vue';
export default {
    name: "DeploymentList",
    components: {
        Drawer
    },
    data() {
        return {
            helpText: constantMessages.BREADCRUMB_HELP["deployment.list"],
            showDeployments: false,
            deploymentList: [],
            CONTEXT_PATH: process.env.VUE_APP_CONTEXT_PATH,
            tableObj: [],
            currentPageSize: [],
            showNoRecords: false,
            fetchCall: false,
            tableData: [],
            filterActive: false,
            filterData: [],

        };
    },
    mounted() {
        Utils.applyFixedHeaderConfiguration(this);
        this.updateDeploymentData();
        const listGroupFilter = document.querySelector('input#list-group-filter')
        listGroupFilter.addEventListener('input', (event) => {
            this.filterItems(event)
        })
    },

    methods: {
        filterItems(event) {
            const listGroupComponent = document.querySelector('.mcc-list-group')
            window.filterTimeout && clearTimeout(window.filterTimeout)

            window.filterTimeout = setTimeout(() => {
                const filter = event.target.value.toLowerCase()
                const items = listGroupComponent.querySelectorAll('li')

                // clear previous filter and apply new
                items.forEach(item => item.classList.remove('mu-d-none'))
                items.forEach(item => {
                    if (!item.innerText.toLowerCase().includes(filter)) item.classList.add('mu-d-none')
                })
            }, 250)
        },

        updateDeploymentData() {
            let self = this;

            DeploymentAPI.getDeployments().then(result => {
                self.deploymentList = result.data;
                self.showDeployments = result.data.length > 0;
                self.showNoRecords = result.data.length == 0;
                self.tableData = result.data;
                self.fetchCall = true;

            });
        },
        redirectToLink(rowData) {
            this.$router.push(this.CONTEXT_PATH + "/processengine/deployment/" + rowData.id)
        },
        handleExpand(key) {
            this.initDeploymentTable(key);
        },
        initDeploymentTable(key) {
            let self = this;
            if (this.tableObj[key] == null) {
            if (self.currentPageSize[key] == null) {
                    self.currentPageSize[key] = 10;
                };
            let deploymentTime = self.deploymentList[key].deploymentDate;
            let deploymentTimeFormated = "";
            if (deploymentTime != null && deploymentTime != "") {
                deploymentTimeFormated = Utils.getMomentDateString(deploymentTime);
            }
            let filteredList = [{
                ID: self.deploymentList[key].id,
                id: self.deploymentList[key].id,
                prettyDeploymentTime: self.deploymentList[key].prettyDeploymentTime,
                deploymentTime: deploymentTimeFormated
            }];
            self.deploymentList[key].deployedList.forEach(element => {
                deploymentTime = element.deploymentTime;
                deploymentTimeFormated = ""
                if (deploymentTime != null && deploymentTime != "") {
                    deploymentTimeFormated = Utils.getMomentDateString(element.deploymentDate);
                }
                element["ID"] = element.id;
                element["deploymentTime"] = deploymentTimeFormated;
                filteredList.push(element);
            });
            let responseData = {
                totalCount: 0,
                data: filteredList
            };
            responseData.totalCount = filteredList.length;
            const table = document.querySelector('#myTable' + key);
            this.tableObj[key] = window.tableFactory.create(table, {
                bordered: true,
                striped: true,
                emptyTemplate: '<p class="text-center m-0">No process deployments found</p>',
                loadingTemplate: '<p class="text-center m-0">Loading...</p>',
                columnSearch: false,
                pageSize: self.currentPageSize[key],
                debounceTime: 1000,
                schema: {
                    properties: {
                        ID: {
                            type: "string",
                            title: "ID",
                            sortable: true,
                            columnSearch: false,
                            color: "link",
                            template(rowData, html) {
                                return html `<button class="mcc-button mcc-button--anchor " onclick="${(e) => self.redirectToLink(rowData)}" >${rowData.id}</button>`;
                            }
                        },
                        prettyDeploymentTime: {
                            type: "string",
                            title: "Deployment time",
                            template: '<div><u>{{prettyDeploymentTime}}</u><div>{{deploymentTime}}</div></div>',
                            sortable: false,
                            columnSearch: false
                        }
                    }
                },
                data: () => {
                    if (!self.filterActive) {
                        return responseData;
                    } else {
                        self.filterActive = false;
                        let responseData = {
                            totalCount: self.filterData.length,
                            data: self.filterData
                        };
                        return responseData;
                    }
                },
                onAction: (table, action, obj) => {
                    let rowData = obj[0].rowData;
                    // this.$router.push(
                    //     self.CONTEXT_PATH + "/processengine/deployment/" + rowData.id
                    // );

                }
            });
            }
        }
    }
};
</script>

<style scoped>
.mc-card-deck .mc-card {
    height: 120px;
    margin-left: 0;
    margin-right: 0;
}

.mc-list-group mosaic-badge {
    display: flex;
    flex: 1;
    justify-content: flex-end;
}

.mcc-list-group-li {
    border-bottom: 1px solid #666679;
}

.mcc-list-group {
    border-top: 1px solid #666679;
    border-left: 1px solid #666679;
    border-right: 1px solid #666679;
}
</style>
